import React, { useState, useEffect } from "react";
import { FaPlus, FaTimes } from "react-icons/fa";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css"; // Import calendar styles
import "./leaverequest.css";
import { useAlert } from "react-alert";
import axios from "axios";
import { APIURL } from "../../Global";
import RosterView from "./RosterView";
const LeaveList = () => {
  const [isAddLeaveVisible, setIsAddLeaveVisible] = useState(false);
  const [startDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
  const today = new Date().toISOString().split("T")[0];
  const [leaveData, setLeaveData] = useState({
    type: "",
    fromDate: "",
    toDate: "",
    reason: "",
  });
  const alert = useAlert();
  const [leaveApplications, setLeaveApplications] = useState([]);
  const [reload, setReload] = useState(false);
  const leaveOptions = [
    { value: "AL", label: "Annual Leave" },
    { value: "CL", label: "Casual Leave" },
    { value: "SL", label: "Sick Leave" },
    { value: "ML", label: "Maternity Leave" },
    { value: "marriage_leave", label: "Marriage Leave" },
    { value: "paternity_leave", label: "Paternity Leave" },
    { value: "bereavement_leave", label: "Bereavement Leave" },
    { value: "comp_off", label: "Compensatory Off" },
    { value: "LOP", label: "Loss Of Pay Leave" },
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      const sidebar = document.querySelector(".add-leave-form");
      if (sidebar && !sidebar.contains(e.target)) {
        setIsAddLeaveVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isAddLeaveVisible]);

  useEffect(() => {
    const tokenString = sessionStorage.getItem("usertoken");
    let v2 = tokenString?.replace(/["]+/g, "");

    axios
      .get(`${APIURL}/api/v1/service-provider/nurse-planned-leave/`, {
        headers: { Authorization: "Token " + v2 },
      })
      .then((res) => {
        if (res && res.data.details) {
          setLeaveApplications(res.data.details);
        } else {
          setLeaveApplications([]);
        }
      })
      .catch((error) => { });
  }, [reload]);

  const handleAddLeaveClick = () => setIsAddLeaveVisible(true);
  const handleCloseAddLeave = () => setIsAddLeaveVisible(false);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLeaveData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = () => {
    if (leaveData.type === "") {
      alert.error("Select leave type")
    } else if (leaveData.fromDate == "") {
      alert.error("Select Dates")
    } else if (leaveData.toDate == "") {
      alert.error("Select end date")
    } else {
      const tokenString = sessionStorage.getItem("usertoken");
      let str = tokenString.replace(/["]+/g, "");

      const dataToUpdate = {
        leave_type: leaveData.type,
        from_date: leaveData.fromDate,
        to_date: leaveData.toDate,
        remarks: leaveData.reason,
      };

      axios
        .post(`${APIURL}/api/v1/service-provider/nurse-planned-leave/`, dataToUpdate, {
          headers: {
            Authorization: "Token " + str,
            "Content-Type": "application/json",
          },
        })
        .then((res) => {
          if (res.data.status === "success") {
            alert.success("Request submitted");
            setLeaveData({
              type: "",
              fromDate: "",
              toDate: "",
              reason: "",
            })
            setReload(!reload);
          } else {
            alert.error(res.data.message);
          }
        })
        .catch(() => {
          alert.error("Error in submission");
        });
      setIsAddLeaveVisible(false);
    }
  };

  const getLeaveLabel = (leaveType) => {
    const leave = leaveOptions.find((option) => option.value === leaveType);
    return leave ? leave.label : leaveType; // Fallback to the raw value if no match is found
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();
    return `${day} ${month}, ${year}`;
  };

  const calculateDays = (fromDate, toDate) => {
    const from = new Date(fromDate);
    const to = new Date(toDate);
    const differenceInTime = to - from;
    const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24) + 1;
    return differenceInDays > 1 ? `${differenceInDays} days` : `${differenceInDays} day`;
  };

  return (
    <div className="leave-request">
      {!isAddLeaveVisible && <div className="content-header col-6">
        <RosterView startDate={startDate} setStartDate={setStartDate} />
      </div>
      }
      <div className="content-header col-6">
        <label style={{ display: 'flex', flexDirection: 'column', marginLeft: "auto", backgroundColor: "#2168ac", color: "#fff", padding: "5px", borderRadius: "5px", cursor: "pointer" }} onClick={handleAddLeaveClick} >New Request</label>
        <div className="content-container">
          < div className={`leave-list ${isAddLeaveVisible ? "shift-left" : ""}`}>
            <div className="applications">
              {leaveApplications?.length > 0 &&
                leaveApplications.map((leave) => (
                  <div key={leave.id} className={`application ${leave.is_approved === "approved" ? "approved" : leave.is_approved === "rejected" ? "dewclined" : "awaiting"}`}>
                    <p className={`status ${leave.is_approved === "approved" ? "approved" : leave.is_approved === "rejected" ? "rejected" : "awaiting"}`} style={{ width: "auto" }}>{leave.is_approved}</p>
                    <p className="type">{getLeaveLabel(leave.leave_type)} Request</p>
                    <p className="date">{formatDate(leave.from_date)} - {formatDate(leave.to_date)} ({calculateDays(leave.from_date, leave.to_date)})</p>
                    {leave.remarks && <p className="category">{leave.remarks}</p>}
                    <p className="bttn">
                      <label style={{ textTransform: 'capitalize' }}>{leave.is_approved} Approval</label>
                      <button>Cancel</button>
                    </p>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div >
      {isAddLeaveVisible && (
        <div className="content-header col-6">
          <div className="add-leave-form">
            <div className="close-btn" onClick={handleCloseAddLeave}>
              <FaTimes size={20} />
            </div>
            <h2>Request Leave</h2>
            <form>
              <div className="form-group">
                <label>Leave Type</label>
                <select name="type" value={leaveData.type} onChange={handleInputChange}>
                  <option value="">Select Leave Type</option>
                  {leaveOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>From Date</label>
                <input type="date" name="fromDate" min={today} max={leaveData.toDate !== "" && leaveData.toDate} value={leaveData.fromDate} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>To Date</label>
                <input type="date" name="toDate" disabled={leaveData.fromDate === ""} min={leaveData.fromDate} value={leaveData.toDate} onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Reason (optional)</label>
                <textarea name="reason" value={leaveData.reason} onChange={handleInputChange} placeholder="Add a reason (optional)" />
              </div>
              <button type="button" onClick={handleSubmit}>
                Submit Request
              </button>
            </form>
          </div>
        </div>
      )}
    </div >
  );
};

export default LeaveList;
